import { BespokeFormPageComponent } from '../product-bespoke-form/bespoke-form-page/bespoke-form-page.component';
import { BespokeFormModalComponent } from '../product-bespoke-form/bespoke-form-modal/bespoke-form-modal.component';
import { BespokeSubtypeSelectionFormComponent } from '../product-bespoke-form/bespoke-subtype-selection-form/bespoke-subtype-selection-form.component';
import { BespokeCornersFormComponent } from '../product-bespoke-form/bespoke-corners-form/bespoke-corners-form.component';
import { BespokeRiserFormComponent } from '../product-bespoke-form/bespoke-riser-form/bespoke-riser-form.component';
import { BespokeSubtypeFormComponent } from '../product-bespoke-form/bespoke-subtype-form/bespoke-subtype-form.component';
import { BespokeSizeFormComponent } from '../product-bespoke-form/bespoke-size-form/bespoke-size-form.component';
import { BespokeWeatheringFormComponent } from '../product-bespoke-form/bespoke-weathering-form/bespoke-weathering-form.component';
import { BespokeBuilderFormComponent } from '../product-bespoke-form/bespoke-builder-form/bespoke-builder-form.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { NgSelectModule } from '@ng-select/ng-select';

const routes: Routes = [
    { path: '', component: BespokeFormPageComponent, pathMatch: 'full' },
    { path: 'bespoke/:type/:finish/:rangeId', component: BespokeBuilderFormComponent, pathMatch: 'full' },
];

@NgModule({
    declarations: [
        BespokeBuilderFormComponent,
        BespokeWeatheringFormComponent,
        BespokeSizeFormComponent,
        BespokeSubtypeFormComponent,
        BespokeRiserFormComponent,
        BespokeCornersFormComponent,
        BespokeSubtypeSelectionFormComponent,
        BespokeFormModalComponent,
        BespokeFormPageComponent,
    ],
    imports: [
        CommonModule,
        [RouterModule.forChild(routes)],
        SharedModule,
        FormsModule,
        ReactiveFormsModule,
        AngularSvgIconModule,
        NgSelectModule,
    ],
    exports: [
        [RouterModule],
        BespokeBuilderFormComponent,
        BespokeWeatheringFormComponent,
        BespokeSizeFormComponent,
        BespokeSubtypeFormComponent,
        BespokeRiserFormComponent,
        BespokeCornersFormComponent,
        BespokeSubtypeSelectionFormComponent,
        BespokeFormModalComponent,
        BespokeFormPageComponent,
    ]
})
export class BespokeFormModule {
}
